const action = "leave";

const leave = (onDone) => ({
  action,
  title: "Leave",
  hotkey: "l",
  enabled: () => true,
  execute: () => {
    onDone();
    return {};
  },
});

export default leave;
